import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';

@Component({
  selector: 'app-catalogs-catalogs-card',
  templateUrl: './catalogs-catalogs-card.component.html',
  styleUrls: ['./catalogs-catalogs-card.component.scss']
})
export class CatalogsCatalogsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enabledCount: any;
  disabledCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('catalogs-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('catalogs-counts-spinner');
      this.showCounter = true;
      this.enabledCount = this.data.availableCatalogs;
      this.disabledCount = this.data.unavailableCatalogs;
    } else if ('-' === this.data) {
      this.enabledCount = '-';
      this.disabledCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('catalogs-counts-spinner');
    }
  }
}
